<div class="flex flex-col gap-4">
  <h3 class="font-medium text-text-primary" tuiTitle="m">
    {{ section().title }}
  </h3>
  <pxc-form-decoration position="before" [content]="section().decorations?.before" />

  @if (section().modules.length) {
    <pxc-form-manual-trigger
      [moduleInputs]="formInputs()"
      [modules]="section().modules"
      [targetId]="section().id"
      (moduleReset)="moduleReset.emit($event)"
      (moduleTriggered)="moduleTriggered.emit($event)" />
  }

  <section class="flex flex-col gap-4">
    @for (question of questions(); track question.id) {
      <pxc-form-question
        [control]="sectionGroup().get(question.id)!"
        [moduleInputs]="formInputs()"
        [question]="question"
        [readOnly]="readOnly()"
        (moduleReset)="moduleReset.emit($event)"
        (moduleTriggered)="moduleTriggered.emit($event)" />
    }
  </section>

  <pxc-form-decoration position="after" [content]="section().decorations?.after" />
</div>
